module.exports = __webpack_public_path__ + "static/projectflow-93e68b71acc7ecb04af9b28ac3b8b356.jpg";